import React from "react";
import BlueTag from "../ui/BlueTag";
import Heading from "../ui/Heading";
import Cta from "../ui/Cta";
import backgroundImage from "../../../assets/images/webp/choose-us-bg-image.webp";
const ContactUs = ({ className = "" }) => {
  return (
    <div className={className}>
      <div className="py-[67px] bg-custom-green rounded-[24px] max-2xl:max-w-[1140px] mx-auto relative max-md:px-5">
        <img
          src={backgroundImage}
          className="absolute top-0 left-0 h-full w-full object-cover object-center z-0"
          alt="background layer"
        />
        <div className="max-w-[708px] mx-auto text-center relative z-10">
          <BlueTag variant="white" center>
            Contact Us
          </BlueTag>
          <Heading
            variant="white"
            className="pt-1 sm:pt-3 md:pt-5 max-lg:max-w-[645px] mx-auto">
            Want to achieve your goals? Let's get started today!
          </Heading>
          <div className="flex max-sm:flex-col items-center gap-3 justify-center mt-6 sm:mt-8 md:mt-10">
            <Cta className="sm:max-w-[248px] w-full" href="/contact-us">
              Get In Touch
            </Cta>
            <Cta variant="outline" className="sm:max-w-[250px] w-full">
              Have You Any Question
            </Cta>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
